import { Component, HostListener, OnInit, AfterViewInit } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { LoanService } from '../../../../../service/finzy-flex/loan/loan.service';
import { LoanList } from '../../../../../model/finzy-flex/loan-list.model';
import { ProductList } from '../../../../../model/finzy-flex/product-list.model';
import { Keys, StorageService } from '../../../../../service/storage.service';
import { ConfigService } from '../../../../../service/config.service';
import * as moment from 'moment-timezone';
import { LoanSettlementNegotiationService } from '../../../../../service/rbi-compliance/loan-settlement-negotiation.service';
import { LoanSettlementNegotiation } from '../../../../../model/rbi-compliance/loan-settlement-negotiation.model';

@Component({
    selector: 'app-flex-loans',
    templateUrl: './flex-loans.component.html',
    styleUrls: ['./flex-loans.component.scss'],
    providers: [MatPaginatorIntl]
})

export class FlexLoansComponent implements OnInit, AfterViewInit {
    private readonly matPaginatorIntl: MatPaginatorIntl;
    private readonly storageService: StorageService;
    private readonly activatedRoute: ActivatedRoute;
    private readonly loanService: LoanService;
    private readonly configService: ConfigService;
    private readonly loanSettlementNegotiationService: LoanSettlementNegotiationService;
    loanSettlementNegotiation: LoanSettlementNegotiation;
    pageLength: number;
    pageSize: number = 10;
    showTotalPages: number = 4;
    selectedProductType = 'All';
    productTypes = [];
    productsList: ProductList;
    loansList: LoanList;
    duplicateLoansList: LoanList;
    fromDatePlaceHolder = 'Date From';
    toDatePlaceholder = 'Date To';
    fromDateSelected: Date = null;
    toDateSelected: Date = null;
    constructor(
        matPaginatorIntl: MatPaginatorIntl,
        storageService: StorageService,
        activatedRoute: ActivatedRoute,
        loanService: LoanService,
        configService: ConfigService,
        loanSettlementNegotiationService: LoanSettlementNegotiationService
    ) {
        this.matPaginatorIntl = matPaginatorIntl;
        this.storageService = storageService;
        this.loanService = loanService;
        this.configService = configService;
        this.loanSettlementNegotiationService = loanSettlementNegotiationService;
        activatedRoute.data.subscribe((data) => {
            this.productsList = data.product;
        });
    }

    @HostListener('window:resize', ['$event'])
    onChangeScreenSize(event) {
        this.checkScreenSize();
    }

    private checkScreenSize() {
        if (window.innerWidth <= 480) {
            this.showTotalPages = 2;
            this.fromDatePlaceHolder = 'From';
            this.toDatePlaceholder = 'To';
        }
        else {
            this.showTotalPages = 4;
            this.fromDatePlaceHolder = 'Date From';
            this.toDatePlaceholder = 'Date To';
        }
    }

    private async getSubProductsList() {
        this.productTypes = ['All'];
        this.productsList.data.forEach((product) => {
            this.productTypes.push(product.code);
        });
        const sortAlphaNum = (currentData, nextData) => currentData.localeCompare(nextData, 'en', { numeric: true })
        this.productTypes = this.productTypes.sort(sortAlphaNum);
    }

    private paginationDetails() {
        this.pageLength = this.loansList?.total;
        this.pageSize = this.loansList?.count;
    }

    private getLenderId(): string {
        return this.storageService.getItem(Keys.LENDER_ID);
    }

    private async getLoansList(pageSize: number = 10, page?: number, loanShortId?: string, productCodes?: string, investmentStartDate?: Date, investmentEndDate?: Date, sort?: string) {
        this.duplicateLoansList = null;
        this.loansList = await this.loanService.getLoansList('lender', this.getLenderId(), pageSize, page, loanShortId, productCodes, investmentStartDate, investmentEndDate, sort);
        this.duplicateLoansList = this.loansList;
        this.loansList?.data.forEach((loan) => {
            const expiryTime = moment(loan.investmentTime).add(this.configService.getNoOfHoursForReversalExpiration(), 'hours').toDate();
            loan.isLoanReversible = moment().isBefore(expiryTime);
        });
        return this.loansList;
    }

    async ngOnInit() {
        this.matPaginatorIntl.itemsPerPageLabel = 'Show';
        await this.getSubProductsList();
        await this.getLoansList();
        this.paginationDetails();
        this.getLoanSettlementNegotiationByLenderId();
    }

    async ngAfterViewInit() {
        this.checkScreenSize();
    }

    async filterByProductCode(value: string) {
        this.selectedProductType = value;
        if (this.selectedProductType == 'All') {
            await this.getLoansList();
        } else {
            await this.getLoansList(null, null, null, value, this.fromDateSelected, this.toDateSelected);
        }
        this.pageLength = this.loansList.total;
    }

    async searchLoanById(value: string) {
        if (value.length >= 8) {
            return await this.getLoansList(null, null, value, null, this.fromDateSelected, this.toDateSelected);
        }
        if (value.length == 0) {
            return await this.getLoansList();
        }
    }

    async pageChangeEvent(event) {
        await this.getLoansList(event.pageSize, event.pageIndex, null, (this.selectedProductType !== 'All') ? this.selectedProductType : null, this.fromDateSelected, this.toDateSelected);
        this.pageLength = this.loansList.total;
    }

    async sorting(value: string) {
        await this.getLoansList(null, null, null, null, this.fromDateSelected, this.toDateSelected, value);
        this.pageLength = this.loansList.total;
    }

    async dateFilter(dateType: 'fromDate' | 'toDate', event) {
        (dateType == 'fromDate') && (this.fromDateSelected = moment(event).format('YYYY-MM-DD'));
        (dateType == 'toDate') && (this.toDateSelected = moment(event).format('YYYY-MM-DD'));
        if (this.fromDateSelected && this.toDateSelected) {
            moment(this.fromDateSelected).isSameOrBefore(this.toDateSelected) && await this.getLoansList(10, null, null, null, this.fromDateSelected, this.toDateSelected);
        }
    }

    public async getLoanSettlementNegotiationByLenderId() {
        this.loanSettlementNegotiationService.getLoanSettlementNegotiationByLenderId(this.getLenderId())
            .then((res) => {
                console.log("==== ", res);
                this.loanSettlementNegotiation = res;
            })
            .catch((err) => {
                console.log(err)
            })
    }

    public navigateToLoanSettlementPage() {
        console.log("navigaet")
    }
}